import BaseCRUDReducer from '../CRUDReducer';
import { streamAction } from '../../actions/stream/liveStadiumStream';

class StreamCrudReducer extends BaseCRUDReducer {
  initState = {
    filter: {
      streamType: 'upcoming'
    }
  };
}

const CRUDReducer = new StreamCrudReducer(streamAction);

export default (state, action) => CRUDReducer.run(state, action);



// WEBPACK FOOTER //
// ./src/reducers/stream/liveStadiumStream.js